// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"X9s-nQkXCtaRIBduHANvP","header":"_2uicXdWhNdP6ey6xlXhDsm","italicText":"NfCwoCQ0pY68NUwdv036m"};